var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTransactionsRules({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.63333H18.3333",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.85 1.66667H16.4833C17.9667 1.66667 18.3333 2.03334 18.3333 3.50001V6.92501C18.3333 8.39167 17.9667 8.75834 16.4833 8.75834H11.85C10.3667 8.75834 10 8.39167 10 6.92501V3.50001C10 2.03334 10.3667 1.66667 11.85 1.66667Z",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 14.2167H9.99996",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51663 11.25H8.14996C9.63329 11.25 9.99996 11.6167 9.99996 13.0833V16.5083C9.99996 17.975 9.63329 18.3417 8.14996 18.3417H3.51663C2.03329 18.3417 1.66663 17.975 1.66663 16.5083V13.0833C1.66663 11.6167 2.03329 11.25 3.51663 11.25Z",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 12.5C18.3333 15.725 15.725 18.3333 12.5 18.3333L13.375 16.875",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 7.50001C1.66663 4.27501 4.27496 1.66667 7.49996 1.66667L6.62497 3.12501",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTransactionsRules);
export default __webpack_public_path__ + "static/media/ic_transactions_rules.f714d2808b6e10cdbbd3d9779340dfdf.svg";
export { ForwardRef as ReactComponent };